import React from 'react';
import {StoreImageRequestParams} from "./models/store-image-params";
import {Image} from "../image/image";
import {StoreMetadataModel} from "./models/store-metadata-model";
import classNames from "classnames";

export const StoreIconLink = ({
                                alt,
                                title,
                                storeName,
                                controller,
                                className,
                                url,
                                onClick,
                                width,
                                height,
                                nofollow
                              }) => {
  const {device: {isSmallView}} = controller;
  const socialMetaData: StoreMetadataModel = new StoreMetadataModel({alt, title});
  const socialLogoParams: StoreImageRequestParams = new StoreImageRequestParams(storeName, socialMetaData, width, height);

  const linkProps = {
    className: classNames('store-icon-link', {'store-icon-link-small-view' : isSmallView}, className),
    href: url,
    target: '_blank',
    rel: nofollow ? "nofollow" : undefined,
    onClick: () => onClick && onClick()
  }

  const imageProps = {
    width,
    height,
    src: socialLogoParams,
    style: {
      maxWidth: width,
      maxHeight: height
    }
  }

  return (
    <a {...linkProps}>
      <Image {...imageProps}/>
    </a>
  );
}
